// extracted by mini-css-extract-plugin
export default {"coastCalendarItem":"CoastFeedCalendar-module_coastCalendarItem_hkGKs","monthTitle":"CoastFeedCalendar-module_monthTitle_e1JF5"};